import { Inject, Injectable } from '@angular/core'
import { LOGGER_SERVICE } from '../logger/logger.config'
import { LoggerService } from '../logger/logger.interface'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { EXPERIENCE_API_LEAGUES_BASE_PATH, EXPERIENCE_API_VERSION } from '../app.config'
import { ListContainerLayoutModel } from '@flocasts/experience-service-types'

@Injectable({
  providedIn: 'root'
})
export class LeaguesDataService {
  // prettier-ignore
  constructor(
    @Inject(LOGGER_SERVICE) private readonly log: LoggerService,
    private readonly http: HttpClient
  ) {}

  public getLeaguesByNavId(navId: string | null): Observable<ListContainerLayoutModel> {
    this.log.trace(`LeaguesDataService: Requesting Leagues List`, {})
    return this.http.get<ListContainerLayoutModel>(EXPERIENCE_API_LEAGUES_BASE_PATH, {
      params: {
        version: EXPERIENCE_API_VERSION,
        nav_id: navId ?? '' // BFF requires a nav_id, but allowing this means we get the error message back
      }
    })
  }
}
